import styled from 'styled-components';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';

export const LayoutWrapperStyled = styled.div`
  display: flex;
`;

export const ContentStyled = styled.main`
  width: calc(100% - 33.5rem);
  min-height: 100vh;

  ${breakpointsMQ4.xl.down} {
    margin: 0 auto;
    padding-top: 5rem;
    width: 100%;
  }
`;
